export default __webpack_public_path__ + "static/media/katalonLogoFullNoColor.7ae16eb4.svg";